import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import DynamicIcon from "../components/DynamicIcon";
import { getCarriersList, getCarrierDetail, resetSelectedCarrier, selectCarriersList, selectCarriersLoading } from "../redux/carriers/carriersSlice";
import { selectAccountData } from "../redux/main/accountSlice";
import { closeModal, selectRightModalId, selectRightModalIsOpen, selectRightModalIsRefreshNow, selectRightModalmode, setModal } from "../redux/rightModalSlice";
import LoadingSection from "../components/LoadingSection";
import DynamicTitle from "../components/DynamicTitle";
import CarrierCard from "../components/carriersPage/CarrierCard";
import RightModal from "../components/templates/RightModal";
import AddEditCarrier from "../components/carriersPage/AddEditCarrier";
import ViewCarrier from "../components/carriersPage/ViewCarrier";

export default function CarriersList() {
    const dispatch = useDispatch();
    const carriersList = useSelector(selectCarriersList);
    const carriersLoading = useSelector(selectCarriersLoading);
    const accountData = useSelector(selectAccountData);
    const token = localStorage.getItem('installamelo-auth-token');
    
    // RightModal gestita tramite Redux
    const rightModalIsOpen = useSelector(selectRightModalIsOpen);
    const rightModalMode = useSelector(selectRightModalmode);
    const rightModalCarrierId = useSelector(selectRightModalId);
    
    // Carica i corrieri quando il componente viene montato
    useEffect(() => {
        if (accountData?._id) {
            dispatch(getCarriersList({
                accountId: accountData._id,
                token
            }));
        }
    }, [dispatch, accountData]);
    
    // Avvio il refresh dei dati quando isRefreshNow della RightModal si attiva
    const rightModalIsRefreshNow = useSelector(selectRightModalIsRefreshNow);
    useEffect(() => {
        if (rightModalIsRefreshNow && accountData?._id) {
            dispatch(getCarriersList({
                accountId: accountData._id,
                token
            }));
        }
    }, [rightModalIsRefreshNow, dispatch, accountData]);
    
    // Carica i dettagli del corriere quando il modale viene aperto per modifica o visualizzazione
    useEffect(() => {
        if (rightModalIsOpen && rightModalCarrierId && (rightModalMode === 'edit' || rightModalMode === 'view')) {
            dispatch(getCarrierDetail({
                carrierId: rightModalCarrierId,
                token
            }));
        }
    }, [rightModalIsOpen, rightModalCarrierId, rightModalMode, dispatch, token]);
    
    // Reset del corriere selezionato quando si chiude il modale
    useEffect(() => {
        if (!rightModalIsOpen) {
            dispatch(resetSelectedCarrier());
        }
    }, [rightModalIsOpen, dispatch]);
    
    // Gestisce il click sul bottone di nuovo corriere
    const handleAddCarrier = () => {
        dispatch(resetSelectedCarrier());
        dispatch(setModal({
            mode: 'add'
        }));
    };
    
    return (
        <div className="page">
            {carriersLoading && <LoadingSection isFixed />}
            <DynamicTitle title="Corrieri" />
            
            <h1>Corrieri</h1>
            
            <div className="flex justify-end mb-4">
                <button 
                    className="primary" 
                    onClick={handleAddCarrier}
                >
                    <DynamicIcon iconClass="fa-solid fa-plus" />
                    Nuovo Corriere
                </button>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {carriersList && carriersList.length > 0 ? (
                    carriersList.map((carrier, index) => (
                        <CarrierCard
                            key={carrier._id}
                            carrier={carrier}
                            index={index}
                        />
                    ))
                ) : !carriersLoading ? (
                    <div className="col-span-full text-center text-gray-500 py-8">
                        Nessun corriere disponibile. Crea il tuo primo corriere!
                    </div>
                ) : null}
            </div>
            
            {/* RIGHT MODAL per inserimento, modifica o visualizzazione */}
            {
                rightModalIsOpen && (
                    <RightModal width="w-4/5">
                        {rightModalMode === 'add' && (
                            <AddEditCarrier mode="add" />
                        )}
                        {rightModalMode === 'edit' && rightModalCarrierId && (
                            <AddEditCarrier mode="edit" />
                        )}
                        {rightModalMode === 'view' && rightModalCarrierId && (
                            <ViewCarrier />
                        )}
                    </RightModal>
                )
            }
        </div>
    );
}
